/**
 * Data layer for `igaming-self-excluded-player-filter-never-credit-a`. Thin typed fetch wrappers over /api/v1/igaming-self-excluded-player-filter-never-credit-a.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface IgamingSelfExcludedPlayerFilterNeverCreditARow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListIgamingSelfExcludedPlayerFilterNeverCreditAResponse {
	count: number;
	items: IgamingSelfExcludedPlayerFilterNeverCreditARow[];
}

export interface CreateIgamingSelfExcludedPlayerFilterNeverCreditABody {
	[key: string]: unknown;
}

const BASE = "/api/v1/igaming-self-excluded-player-filter-never-credit-a";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListIgamingSelfExcludedPlayerFilterNeverCreditAResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListIgamingSelfExcludedPlayerFilterNeverCreditAResponse>(res);
}

export async function create(body: CreateIgamingSelfExcludedPlayerFilterNeverCreditABody): Promise<IgamingSelfExcludedPlayerFilterNeverCreditARow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<IgamingSelfExcludedPlayerFilterNeverCreditARow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const igamingSelfExcludedPlayerFilterNeverCreditAQueryKeys = {
	all: ["igaming-self-excluded-player-filter-never-credit-a"] as const,
	list: () => [...igamingSelfExcludedPlayerFilterNeverCreditAQueryKeys.all] as const,
	detail: (id: string) => [...igamingSelfExcludedPlayerFilterNeverCreditAQueryKeys.all, id] as const,
};
